//include 21
jQuery(function () {
    var transitionEndEvents = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";

    var tresholdiE = 0;

    if ($("html").hasClass("microsoft-edge") || $("html").hasClass("internet-explorer")) {
        tresholdiE = 5;
    }


    var treshold = 70 + tresholdiE;

    if ($(window).width() < 640) {
        treshold = 50 + tresholdiE;
    }

    /*
    if(Foundation.MediaQuery.current != 'small' && $(".content article.contentbar").length > 0 && $(".content article.sidebar").length > 0){
        var $contentHeight = $(".content article.contentbar").outerHeight();
        var $sidebarHeight = $(".content article.sidebar").outerHeight();

        if($contentHeight <= $sidebarHeight){
            $(".content article.contentbar .more-wrapper").each(function () {
                //$(this).css("max-height","none");
                //$(this).attr("data-strict","data-strict");

                treshold = 10000;
            });
        }
    }
    */

    if (disableReadMore() == true) {
        //treshold = 10000;
    }

    $(".more-wrapper").each(function () {
        addReadMoreButtons($(this), transitionEndEvents, treshold);
    });

    var beforeMediaQuery = Foundation.MediaQuery.current;

    $(window).on("orientationchange resize", function () {
        if (beforeMediaQuery != Foundation.MediaQuery.current) {
            beforeMediaQuery = Foundation.MediaQuery.current;

            if ($(window).width() < 640) {
                treshold = 50 + tresholdiE;
            } else {
                //treshold = 50;
                treshold = 70 + tresholdiE;
            }

            if (disableReadMore() == true) {
                //treshold = 10000;
            }

            $(".more-wrapper").each(function () {
                $(this).removeClass('active');
                $(this).removeAttr('style');

                addReadMoreButtons($(this), transitionEndEvents, treshold);
            });
        }
    });


    // hide content which is for tomorrow
    $("[class^='show-on-date-'], [class*=' show-on-date-']").each(function () {
        var $this = $(this);

        var elemDateRes = $this.attr("class").split("show-on-date-");
        var elemShowDate = elemDateRes[1];

        var today = moment().format('YYYY-MM-DD');

        if (elemShowDate == today) {
            $this.show();
        } else {
            $this.hide();
        }
    });
});


var calculateElementsBasedOnOffset = function ($this, fixedPoint, gradientOverlay, treshold) {
    treshold = treshold || 0;
    var offset = fixedPoint.offset();
    var fromTop = offset.top + treshold;
}

function addReadMoreButtons($this, transitionEndEvents, treshold) {
    var callbacks = {
        "open": [],
        "close": [],
        "toggle": [],
        "openEnd": [],
        "closeEnd": [],
        "toggleEnd": []
    };

    var runCallbacks = function (eventName, args) {
        if (!callbacks[eventName])
            return;
        var args = args || {};
        $.each(callbacks[eventName], function (index, callback) {
            callback(args);
        });
    }

    var onOpenClick = function (e) {
        // read-more toggles also sit inside search forms, where a submit would trigger the search
        e.preventDefault();

        var $target = $this;
        if (e.target && $(e.target).closest(".more-wrapper").length > 0) {
            $target = $(e.target).closest(".more-wrapper");
        }

        $target.toggleClass("open");
        if ($target.hasClass("open")) {
            $target.css("max-height", $target.get(0).scrollHeight);
            $target.find(".button-open").attr("title", $target.find(".hide:not(img)").first().text());

            //************parents**********************
            $target.parents('.more-wrapper.active.open').css('max-height', 'none');
            //*****************************************

            $target.one(transitionEndEvents, function () {
                runCallbacks("openEnd");
                $target.parents('.more-wrapper.active.open').each(function () {
                    $(this).css('max-height', $(this).get(0).scrollHeight);
                });
                if ($(".sticky").length > 0) {
                    $('.sticky').foundation('_calc', true);
                }
            });
            runCallbacks("open");

            window.pixelpoint.tagManager.event('einAusKlappenClick', {'eventName': 'ausklappen'});
        } else {
            $target.css("max-height", "");
            if ($target.data().hasOwnProperty("dynamicHeightValue")) {
                $target.css("max-height", $target.data("dynamicHeightValue"));
            }

            $target.find(".button-open").attr("title", $target.find(".show:not(img)").first().text());

            var checkboxGroup = $target.closest(".checkbox-group");

            if (checkboxGroup.length == 0) {

                var $scrollToElement = $target;

                if ($target.parent().hasClass('scrollUpOnCloseReadMore')) {
                    $scrollToElement = $target.parent();
                } else if ($target.parent().parent().hasClass('scrollUpOnCloseReadMore')) {
                    $scrollToElement = $target.parent().parent();
                } else if ($target.parent().parent().parent().hasClass('scrollUpOnCloseReadMore')) {
                    $scrollToElement = $target.parent().parent().parent();
                } else if ($target.parent().parent().parent().parent().hasClass('scrollUpOnCloseReadMore')) {
                    $scrollToElement = $target.parent().parent().parent().parent();
                } else {
                }

                if ($(window).width() < 640) {
                    $("html, body").animate({scrollTop: $scrollToElement.offset().top - $('.header-wrapper .header').height() - 5}, 800);
                } else {
                    //$("html, body").animate({scrollTop:  $scrollToElement.offset().top + $('.header-wrapper .header').height() - 50}, 800);
                    $("html, body").animate({scrollTop: $scrollToElement.offset().top - $('.header-wrapper .header').height() - 10}, 800);
                }
            }

            $target.one(transitionEndEvents, function () {
                runCallbacks("closeEnd");
            });
            runCallbacks("close");
            window.pixelpoint.tagManager.event('einAusKlappenClick', {'eventName': 'einklappen'});
        }

        $(".sticky").each(function () {
            try {
                $(this).foundation('_calc', true);
            } catch (err) {

            }
        });

        runCallbacks("toggle");
        $target.one(transitionEndEvents, function () {
            runCallbacks("toggleEnd");
        });
    };

    var exposed = {
        init: function () {
            if (!$this.is("[data-disable-read-more]")) { // $this.data().hasOwnProperty("disableReadMore")
                if ($this.data().hasOwnProperty("dynamicHeightValue")) { // works only in combination with the data-strict attribute
                    var dynamicHeightVal = $this.data("dynamicHeightValue");
                    $this.css('max-height', parseInt(dynamicHeightVal));
                }
                setTimeout(() => {
                    // +1px to avoid rounding errors
                    if ($this.get(0).scrollHeight > $this.height() + 1) {
                        var difference = $this.get(0).scrollHeight - $this.height();
                        var isStrict = $this.is("[data-strict]");
                        var isVierspalterImageCard = isStrict && $this.hasClass("content-with-img") && $this.closest(".dce-vierspalter").length > 0;

                        // Prevent false positives from tiny layout deltas on vierspalter image cards.
                        if (!isStrict || isVierspalterImageCard) {
                            if (difference <= treshold) {
                                //$this.css("max-height", $this.get(0).scrollHeight);
                                $this.css("max-height", $this.get(0).scrollHeight + 10);
                                return;
                            }
                        } else if ($("html").hasClass("microsoft-edge") || $("html").hasClass("internet-explorer")) {
                            if ($this.get(0).scrollHeight <= $this.height() + 5) {
                                return;
                            }
                        }

                        $this.addClass("active");

                        // with these 2 lines the click is triggerd twice in db-convention-programme slider
                        //$this.find(">.arrow-open .button-open").off("click", onOpenClick);
                        //$this.find(">.arrow-open .button-open").on("click", onOpenClick);
                        $this.find(">.arrow-open .button-open").off("click").on("click", onOpenClick);

                        $this.find(">.arrow-open .button-open").each(function (index, element) {
                            if ($(element).hasClass("open")) {
                                $(element).find(".button-open").attr("title", $(element).find(".hide:not(img)").first().text());
                            } else {
                                $(element).find(".button-open").attr("title", $(element).find(".show:not(img)").first().text());
                            }
                        });
                    } else {
                        if ($this.is("[data-always-active]")) {
                            $this.addClass("active");
                            //$this.find(">.arrow-open .button-open").off("click", onOpenClick);
                            //$this.find(">.arrow-open .button-open").on("click", onOpenClick);
                            $this.find(">.arrow-open .button-open").off("click").on("click", onOpenClick);

                            $this.find(">.arrow-open .button-open").each(function (index, element) {
                                if ($(element).hasClass("open")) {
                                    $(element).find(".button-open").attr("title", $(element).find(".hide").first().text());
                                } else {
                                    $(element).find(".button-open").attr("title", $(element).find(".hide").first().text());
                                }
                            });
                        } else if ($this.data().hasOwnProperty("dynamicHeightValue")) {
                            $this.css('max-height', 'none');
                        } else {
                        }
                    }
                }, 150);
            }
        },
        on: function (eventName, callback) {
            if (!callbacks[eventName])
                return;
            callbacks[eventName].push(callback);
        },
        off: function (eventName, callback) {
            if (!callbacks[eventName])
                return;
            var index = callbacks[eventName].indexOf(callback);
            if (index > -1)
                callbacks[eventName].splice(index, 1);
        },
        open: function (triggerEvent) {
            triggerEvent = triggerEvent || false;
            if ($this.hasClass("open"))
                return;
            $this.addClass("open");
            $this.css("max-height", $this.get(0).scrollHeight);
            if (triggerEvent)
                runCallbacks("open");
        },
        close: function (triggerEvent) {
            triggerEvent = triggerEvent || false;
            if (!$this.hasClass("open"))
                return;
            $this.removeClass("open");
            $this.css("max-height", "");
            if ($this.data().hasOwnProperty("dynamicHeightValue")) {
                $this.css("max-height", $this.data("dynamicHeightValue"));
            }
            if (triggerEvent)
                runCallbacks("close");
        }
    };
    $this.data("show-more", exposed);
    exposed.init();
}


function disableReadMore() {
    if (Foundation.MediaQuery.current != 'small' && $(".content article.contentbar").length > 0 && $(".content article.sidebar").length > 0) {
        var $firstMoreWrapper = $(".content article.contentbar .more-wrapper").first();
        var maxHeight = $firstMoreWrapper.css("max-height");
        $(".content article.contentbar .more-wrapper").css("max-height", "none");

        var $contentHeight = $(".content article.contentbar").outerHeight() - 100;
        var $sidebarHeight = $(".content article.sidebar").outerHeight();

        if ($firstMoreWrapper.hasClass("detailpage-no-gallery") && ($contentHeight + 100) > $sidebarHeight) {
            var newMaxHeight = $sidebarHeight - 250;
            if (newMaxHeight < 450) {
                newMaxHeight = 450;
            }

            $(".content article.contentbar .more-wrapper").css("max-height", newMaxHeight + "px");
        } else {
            $(".content article.contentbar .more-wrapper").css("max-height", maxHeight);
        }

        if ($contentHeight <= $sidebarHeight) {
            return true;
        }
    }

    return false;
}


window.ppComponents = window.ppComponents || {};
window.ppComponents.common = window.ppComponents.common || {};
window.ppComponents.common.showMore = function ($element) {
    var transitionEndEvents = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";

    var tresholdiE = 0;

    if ($("html").hasClass("microsoft-edge") || $("html").hasClass("internet-explorer")) {
        tresholdiE = 5;
    }

    var treshold = 70 + tresholdiE;

    if ($(window).width() < 640) {
        treshold = 50 + tresholdiE;
    }

    $element.each(function () {
        if ($(this).hasClass("active")) {
            return;
        }
        var $this = $(this);
        addReadMoreButtons($this, transitionEndEvents, treshold);
    });
};